import { ArrowRight, BookOpen, Clock3, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import type { Book } from "../types";
import { analysisLabel, formatNumber } from "../utils";

function bookHue(id: string): number {
  return [...id].reduce((sum, char) => sum + char.charCodeAt(0), 0) % 70;
}

export function BookCard({ book }: { book: Book }) {
  return (
    <article className="book-card">
      <div className="book-cover" style={{ "--book-hue": bookHue(book.id) } as React.CSSProperties}>
        <span>{book.language.toUpperCase()}</span>
        <strong>{book.title.slice(0, 1).toUpperCase()}</strong>
        <small>flussik edition</small>
      </div>
      <div className="book-card__body">
        <div>
          <span className={`status-pill status-pill--${book.analysis_status}`}>
            {book.analysis_status === "completed" ? <Sparkles size={13} /> : <Clock3 size={13} />}
            {analysisLabel[book.analysis_status]}
          </span>
          <h3>{book.title}</h3>
          <p>{book.author || "作者未知"}</p>
        </div>
        <div className="book-card__stats">
          <span><strong>{formatNumber(book.token_count)}</strong> 词</span>
          <span><strong>{formatNumber(book.unique_lexeme_count)}</strong> 词条</span>
        </div>
        <div className="book-card__actions">
          <Link className="secondary-button" to={`/books/${book.id}`}>详情</Link>
          <Link className="primary-button" to={`/read/${book.id}`}>
            <BookOpen size={16} />
            开始阅读
            <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </article>
  );
}
